import React from 'react';
import { useStaticQuery } from 'gatsby';
import styled, { x, useColorMode, down, css } from '@xstyled/styled-components';
import { ScreenContainer } from './ScreenContainer';
import { DocSearch } from './DocSearch';
import { NavLink } from './Nav';
import { AppNav } from './AppNav';
const AppHeaderQuery = "148928582";
const OuterHeader = styled.header.withConfig({
  displayName: "AppHeader__OuterHeader",
  componentId: "sc-1h3vgiu-0"
})(["background-color:background;border-bottom-style:solid;border-bottom-width:base;border-bottom-color:layout-border;padding:2 0;height:50;", ""], down('sm', css(["overflow-x:auto;"])));
const NavSkipLink = styled.a.withConfig({
  displayName: "AppHeader__NavSkipLink",
  componentId: "sc-1h3vgiu-1"
})(["text-decoration:none;left:-999px;position:absolute;top:auto;width:1px;height:1px;overflow:hidden;z-index:-999;color:primary;&:focus{background-color:background;border-radius:base;left:auto;top:auto;height:auto;width:max-content;overflow:auto;padding:2;margin:2;text-align:center;z-index:999;}"]);
function useLogo(logos) {
  const [mode] = useColorMode();
  switch (mode) {
    case 'dark':
      return logos.find(logo => logo.name === 'logo-nav-dark') || logos.find(logo => logo.name === 'logo-nav') || null;
    case 'light':
    default:
      return logos.find(logo => logo.name === 'logo-nav-light') || logos.find(logo => logo.name === 'logo-nav') || null;
  }
}
export function AppHeader() {
  const data = useStaticQuery(AppHeaderQuery);
  const logo = useLogo(data.logos.nodes);
  return /*#__PURE__*/React.createElement(OuterHeader, null, /*#__PURE__*/React.createElement(ScreenContainer, null, /*#__PURE__*/React.createElement(NavSkipLink, {
    tabindex: "0",
    href: "#main"
  }, "Skip to content"), /*#__PURE__*/React.createElement(x.div, {
    row: true,
    alignItems: "center",
    flexWrap: "nowrap",
    mx: -2
  }, /*#__PURE__*/React.createElement(x.div, {
    col: true,
    px: 2,
    display: "flex"
  }, /*#__PURE__*/React.createElement(NavLink, {
    row: true,
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "nowrap",
    mx: -2,
    to: "/"
  }, logo ? /*#__PURE__*/React.createElement(x.img, {
    col: "auto",
    px: 2,
    height: 32,
    src: logo.publicURL,
    alt: data.site.siteMetadata.title
  }) : /*#__PURE__*/React.createElement(x.h2, {
    col: "auto",
    flex: "0 1 auto",
    px: 2,
    alignItems: "center",
    fontSize: 18,
    m: 0
  }, data.site.siteMetadata.title))), data.site.siteMetadata.docSearch ? /*#__PURE__*/React.createElement(x.div, {
    col: "auto",
    px: 2,
    display: {
      xs: 'none',
      md: 'block'
    }
  }, /*#__PURE__*/React.createElement(DocSearch, data.site.siteMetadata.docSearch)) : null, /*#__PURE__*/React.createElement(AppNav, {
    col: "auto",
    px: 2
  }))));
}